import { render, staticRenderFns } from "./ProductionNameCell.vue?vue&type=template&id=a5458f4c&scoped=true&"
import script from "./ProductionNameCell.vue?vue&type=script&lang=js&"
export * from "./ProductionNameCell.vue?vue&type=script&lang=js&"
import style0 from "./ProductionNameCell.vue?vue&type=style&index=0&id=a5458f4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5458f4c",
  null
  
)

export default component.exports